import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import checkIconInActive from "@src/assets/vimeoCheck.png";
import checkIconActive from "@src/assets/vimeoCheckActive.png";

interface ServiceAgreeMentProps {
    onAllAgree: () => void;
    onDisAgree: () => void;
}

const TakerServiceAgreeMent = ({ onAllAgree, onDisAgree }: ServiceAgreeMentProps) => {
    const [isAgree, setIsAgree] = useState({
        first: false,
        second: false,
    });

    useEffect(() => {
        if (isAgree.first && isAgree.second) {
            onAllAgree();
        } else {
            onDisAgree();
        }
    }, [isAgree]);

    return (
        <div css={ServiceAgreeMentContainerStyle}>
            <div css={ServiceAgreeMentItemStyle} onClick={() => setIsAgree({ ...isAgree, first: !isAgree.first })}>
                <img src={isAgree.first ? checkIconActive : checkIconInActive} alt="서비스 이용약관" width={20} height={20} />
                <p css={ServiceAgreeMentTextStyle}>
                    모든 서비스는 고객과 전문가 간 신뢰를 기반으로 하며, 미스고는 일부 수수료 외에는 직접적인 관여를 하지
                    않습니다.
                </p>
            </div>
            <div css={ServiceAgreeMentItemStyle} onClick={() => setIsAgree({ ...isAgree, second: !isAgree.second })}>
                <img src={isAgree.second ? checkIconActive : checkIconInActive} alt="서비스 이용약관" width={20} height={20} />
                <p css={ServiceAgreeMentTextStyle}>유찰 시 추가 결제 조건이나 자동 처리 약관을 반드시 확인해야 합니다.</p>
            </div>
        </div>
    );
};

export default TakerServiceAgreeMent;

const ServiceAgreeMentContainerStyle = css`
    width: 100%;
    background-color: #f0f0f0;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const ServiceAgreeMentItemStyle = css`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

const ServiceAgreeMentTextStyle = css`
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 1.4;
`;
